<template>
  <div id="promotions">
    <div class="row">
      <div class="col-md-12">
        <p class="title-form">Create Promotion</p>
        <p class="promotion-title">Promotion Type</p>
        <div class>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="customRadioInline1"
              name="customRadioInline1"
              class="custom-control-input"
              v-model="promotionType"
              value="1"
            />
            <label class="custom-control-label" for="customRadioInline1"># Campaign</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="customRadioInline2"
              name="customRadioInline1"
              class="custom-control-input"
              v-model="promotionType"
              value="2"
            />
            <label class="custom-control-label" for="customRadioInline2">Offer</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="customRadioInline3"
              name="customRadioInline1"
              class="custom-control-input"
              v-model="promotionType"
              value="3"
            />
            <label class="custom-control-label" for="customRadioInline3">Event</label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="promotionType == 1">
      <div class="row basic-information">
        <div class="col-md-12">
          <div class="title-information">Basic Information</div>
        </div>
        <div class="col-md-12">
          <div class="form-group row">
            <label class="col-sm-2 col-form-label"># Campaign Name*</label>
            <div class="col-sm-6">
              <input type="text" class="form-control" placeholder />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              Description*
              <br />(50 words max.)
            </label>
            <div class="col-sm-6">
              <textarea name class="form-control" rows="5"></textarea>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Campaign Hashtag</label>
            <div class="col-sm-6">
              <input type="text" class="form-control" placeholder />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Duration</label>
            <div class="col-sm-5">
              <div class="form-inline">
                <span class="mr-5">From:</span>
                <input type="date" class="form-control mr-5" />
                <span class="mr-5">Until:</span>
                <input type="date" class="form-control" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="title-information">Type of Campaign</div>
        </div>
        <div class="col-md-8">
          <div class="row justify-content-between mx-0">
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="tfc1" name="tfc" class="custom-control-input" />
              <label class="custom-control-label" for="tfc1">Lucky Draw</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="tfc2" name="tfc" class="custom-control-input" />
              <label class="custom-control-label" for="tfc2">Most Shared</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="tfc3" name="tfc" class="custom-control-input" />
              <label class="custom-control-label" for="tfc3">Most Likes</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="tfc4" name="tfc" class="custom-control-input" />
              <label class="custom-control-label" for="tfc4">Decided by Jury</label>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="title-information">Type of Campaign</div>
        </div>
        <div class="col-md-12">
          <button class="btn btn-secondary btn-lg">Load sample terms & conditions</button>
        </div>
        <div class="col-md-8">
          <textarea
            name
            id
            class="form-control"
            rows="25"
            placeholder="Campaign Terms & Conditions"
          ></textarea>
        </div>
        <div class="col-md-12">
          <div class="title-information">Judging Panel</div>
        </div>
        <div class="col-md-8">
          <textarea
            name
            id
            class="form-control"
            rows="25"
            placeholder="If your campaign has a judging panel, you can list them here."
          ></textarea>
        </div>
        <div class="col-md-12">
          <div class="title-information">Prizes</div>
        </div>
        <div class="col-md-8">
          <textarea
            name
            id
            class="form-control"
            rows="10"
            placeholder="Please list the prizes here"
          ></textarea>
        </div>
        <div class="col-md-12">
          <button class="btn btn-lg btn-submit">SUBMIT</button>
        </div>
      </div>
    </div>
    <div v-if="promotionType == 2">
      <div class="row basic-information">
        <div class="col-md-12">
          <div class="title-information">Basic Information</div>
        </div>
        <div class="col-md-12">
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Offer Name*</label>
            <div class="col-sm-6">
              <input type="text" class="form-control" placeholder />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              Description*
              <br />(50 words max.)
            </label>
            <div class="col-sm-6">
              <textarea name class="form-control" rows="5"></textarea>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Duration</label>
            <div class="col-sm-5">
              <div class="form-inline">
                <span class="mr-5">From:</span>
                <input type="date" class="form-control mr-5" />
                <span class="mr-5">Until:</span>
                <input type="date" class="form-control" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="title-information">Connected Products & Services</div>
        </div>
        <div class="col-md-8">
          <textarea
            name
            id
            class="form-control"
            rows="2"
            placeholder="List connected products & services that provide this offer."
          ></textarea>
        </div>
        <div class="col-md-12">
          <div class="title-information">Terms & Conditions</div>
        </div>
        <div class="col-md-8">
          <textarea name id class="form-control" rows="25" placeholder="Offer Terms & Conditions"></textarea>
        </div>
        <div class="col-md-12">
          <button class="btn btn-lg btn-submit">SUBMIT</button>
        </div>
      </div>
    </div>
    <div v-if="promotionType == 3">
      <div class="row basic-information">
        <div class="col-md-12">
          <div class="title-information">Basic Information</div>
        </div>
        <div class="col-md-12">
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Event Name*</label>
            <div class="col-sm-6">
              <input type="text" class="form-control" placeholder />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              Description*
              <br />(50 words max.)
            </label>
            <div class="col-sm-6">
              <textarea name class="form-control" rows="5"></textarea>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Date*</label>
            <div class="col-sm-6  pt-2 pl-3">
              <div class="custom-control custom-checkbox mb-3">
                <input type="checkbox" class="custom-control-input" id="customCheck1" />
                <label class="custom-control-label" for="customCheck1">Full-day event</label>
              </div>
              <div class="form-group row mb-0">
                <label for="" class="col-md-2 col-form-label pt-4">On/From:</label>
                <div class="col-md-4"><input type="date" class="form-control mr-5" /></div>
                <label for="" class="col-md-2 col-form-label pt-4">Until:</label>
                <div class="col-md-4"><input type="date" class="form-control mr-5" /></div>
              </div>
            </div>
          </div>
          <div class="form-group row mb-0">
            <label class="col-sm-2 col-form-label">Time</label>
            <div class="col-sm-6 pt-0 pl-3">
              <div class="form-group row mb-0">
                <label for="" class="col-md-2 col-form-label pt-4">From:</label>
                <div class="col-md-4"><input type="date" class="form-control mr-5" /></div>
                <label for="" class="col-md-2 col-form-label pt-4">Until:</label>
                <div class="col-md-4"><input type="date" class="form-control mr-5" /></div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Booking link:</label>
            <div class="col-sm-6">
              <input type="text" class="form-control" placeholder />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Telephone Number</label>
            <div class="col-sm-6">
              <input type="text" class="form-control" placeholder />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Email*</label>
            <div class="col-sm-6">
              <input type="text" class="form-control" placeholder />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Address*</label>
            <div class="col-sm-6">
              <textarea name class="form-control" rows="3"></textarea>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Country*</label>
            <div class="col-sm-6">
              <input type="text" class="form-control" placeholder />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Region*</label>
            <div class="col-sm-6">
              <input type="text" class="form-control" placeholder />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">City/District</label>
            <div class="col-sm-6">
              <input type="text" class="form-control" placeholder />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Location*</label>
            <div class="col-sm-6 pt-0">
              <div class="form-group row mb-0">
                <label class="col-md-3 col-form-label"><img :src="marker" /> Longitude*:</label>
                <div class="col-md-3"><input type="text" class="form-control" /></div>
                <label class="col-md-3 col-form-label">Latitude*:</label>
                <div class="col-md-3"><input type="text" class="form-control" /></div>
              </div>
              <br />
              <div class="form-group row mb-0">
                <label class="col-md-3 col-form-label"><img :src="what3word" /> What3Words:</label>
                <div class="col-md-9"><input type="text" class="form-control" /></div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Hashtag*</label>
            <div class="col-sm-6">
              <input type="text" class="form-control" placeholder />
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="title-information">Category*</div>
        </div>
        <div class="col-md-8">
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input type="checkbox" class="custom-control-input" id="DO" />
            <label class="custom-control-label" for="DO">DO</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input type="checkbox" class="custom-control-input" id="SHOP" />
            <label class="custom-control-label" for="SHOP">SHOP</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input type="checkbox" class="custom-control-input" id="TASTE" />
            <label class="custom-control-label" for="TASTE">TASTE</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input type="checkbox" class="custom-control-input" id="MOVE" />
            <label class="custom-control-label" for="MOVE">MOVE</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input type="checkbox" class="custom-control-input" id="STAY" />
            <label class="custom-control-label" for="STAY">STAY</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input type="checkbox" class="custom-control-input" id="TOUR" />
            <label class="custom-control-label" for="TOUR">TOUR</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input type="checkbox" class="custom-control-input" id="OTHERS" />
            <label class="custom-control-label" for="OTHERS">OTHERS</label>
          </div>
        </div>
        <div class="col-md-12">
          <div class="title-information">Target Groups</div>
        </div>
        <div class="col-md-8">
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input type="checkbox" class="custom-control-input" id="Adventure" />
            <label class="custom-control-label" for="Adventure">Adventure</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input type="checkbox" class="custom-control-input" id="History-Culture" />
            <label class="custom-control-label" for="History-Culture">History & Culture</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input type="checkbox" class="custom-control-input" id="Buddhist-Tourism" />
            <label class="custom-control-label" for="Buddhist-Tourism">Buddhist Tourism</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input type="checkbox" class="custom-control-input" id="Community-Based-Tourism" />
            <label
              class="custom-control-label"
              for="Community-Based-Tourism"
            >Community Based Tourism</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input type="checkbox" class="custom-control-input" id="Food-Tourism" />
            <label class="custom-control-label" for="Food-Tourism">Food Tourism</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input type="checkbox" class="custom-control-input" id="Nature" />
            <label class="custom-control-label" for="Nature">Nature</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input type="checkbox" class="custom-control-input" id="Family" />
            <label class="custom-control-label" for="Family">Family</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline mr-5">
            <input
              type="checkbox"
              class="custom-control-input"
              id="Meetings-Incentives-Conferences-Exhibitions"
            />
            <label
              class="custom-control-label"
              for="Meetings-Incentives-Conferences-Exhibitions"
            >Meetings, Incentives, Conferences & Exhibitions</label>
          </div>
        </div>
        <div class="col-md-12">
          <button class="btn btn-lg btn-submit">SUBMIT</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import marker from "@/assets/images/marker-promotion.png";
import what3word from "@/assets/images/what3word.png";
export default {
  data() {
    return {
      promotionType: 1,
      marker: marker,
      what3word: what3word
    };
  }
};
</script>

<style lang="scss" scoped>
#promotions {
  width: 100%;

  .title-form {
    font-weight: bold;
    font-size: 24px;
    color: var(--primary-color);
  }
  .promotion-title {
    font-size: 24px;
    color: #58595b;
    line-height: 15px;
  }

  .basic-information {
    position: relative;

    .title-information {
      font-size: 24px;
    }
    .left-area {
      position: absolute;
      margin-left: 2%;
    }
    .right-area {
      position: absolute;
      margin-left: 15%;
      width: 100vw;
    }
  }

  .form-control {
    border: 1px #b9b9b9 solid;
  }

  .form-inline span {
    font-size: 14px;
  }

  .col-form-label,
  .custom-control-label,
  .form-control {
    font-size: 14px;
  }

  .btn,
  .form-control {
    border-radius: 0px;
  }

  .btn-submit {
    background-color: var(--primary-color);
    color: white;
    padding: 15px 50px;
    font-size: 14px;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: var(--primary-color);
    background-color: var(--primary-color);
  }
}
</style>
